import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new7",
  "use": "new7-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"new7\"><defs><style>#new7 .cls-1{fill:none}</style></defs><title>Rectangle 43 Copy 12</title><g id=\"new7_图层_2\" data-name=\"图层 2\"><g id=\"new7_图层_1-2\" data-name=\"图层 1\"><path id=\"new7_Rectangle_43_Copy_12\" data-name=\"Rectangle 43 Copy 12\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new7.svg
// module id = yKm0
// module chunks = 6